__turbopack_context__.v({
  "emailLoginOptionsContainer": "styles-module__izxgLa__emailLoginOptionsContainer",
  "errorText": "styles-module__izxgLa__errorText",
  "loginOptionsContainer": "styles-module__izxgLa__loginOptionsContainer",
  "ssoLoginOptionsContainer": "styles-module__izxgLa__ssoLoginOptionsContainer",
});
